import {Component, Input, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-exg-new-oe-modal',
  templateUrl: './modal-oe-editor.component.html',
  styles: [
  ]
})
export class ModalOeEditorComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  OEDetails = {
    oe_enmName_OETyp: 'OETyp',
    oe_enmIdent_OETyp: -1,
    oe_enmIdent_AnredeTyp: -1,
    oeNPraefix: '',
    oeName: '',
    oeEName: '',
    oe_CrmRolle: -1,
  };

  constructor(
    public excRest: ExcRestService,
    public modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public enumService: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.OEDetails.oe_enmIdent_OETyp = this.data.isCompany ? 3 : 2;
  }

  save(): void {
    this.modal.action(this.OEDetails);
  }

  close(): void {
    this.modal.close();
  }
}
